// frontend/src/components/Navbar/Navbar.js

import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { BarChart2, Menu, X } from 'lucide-react';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isCurrent = (path) => location.pathname === path;

  return (
    <header className="fixed top-4 left-0 right-0 z-50 px-4 flex flex-col items-center pointer-events-none">
      {/* Demo Banner Pill */}
      <div className="pointer-events-auto bg-slate-900/95 backdrop-blur-md text-slate-300 text-[11px] font-mono px-4 py-1 rounded-full border border-slate-800 shadow-md mb-2 flex items-center gap-3">
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
          <span className="text-emerald-400 font-semibold uppercase tracking-wider">Modo Demo</span>
        </div>
        <span className="text-slate-700">|</span>
        <span className="text-slate-400 hidden sm:inline">admin@demo.com · jefe@demo.com · colaborador@demo.com</span>
        <span className="text-slate-700 hidden sm:inline">|</span>
        <span className="text-amber-400 font-bold">demo123</span>
      </div>

      {/* Floating Pill Nav */}
      <div className="pointer-events-auto w-full max-w-3xl bg-white/95 backdrop-blur-md border border-slate-200/90 shadow-xl rounded-full px-5 py-2 flex items-center justify-between transition-all duration-300">
        {/* Logo */}
        <button 
          onClick={() => navigate('/')} 
          className="flex items-center gap-2 font-bold text-slate-900 tracking-tight text-sm hover:opacity-80 transition-opacity"
        >
          <div className="w-6 h-6 rounded-md bg-slate-900 text-white flex items-center justify-center">
            <BarChart2 className="w-3.5 h-3.5" />
          </div>
          <span className="font-extrabold text-base">CommitFlow</span>
        </button>

        {/* Links - Desktop */}
        <div className="hidden md:flex items-center gap-7">
          <Link 
            to="/" 
            className={`text-xs font-semibold transition-colors ${
              isCurrent('/') ? 'text-slate-900 font-bold' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Inicio
          </Link>
          <Link 
            to="/quienes-somos" 
            className={`text-xs font-semibold transition-colors ${
              isCurrent('/quienes-somos') ? 'text-slate-900 font-bold' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Nosotros
          </Link>
          <Link 
            to="/contacto" 
            className={`text-xs font-semibold transition-colors ${
              isCurrent('/contacto') ? 'text-slate-900 font-bold' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Contacto
          </Link>
        </div>

        {/* CTA Button */}
        <div className="flex items-center gap-2">
          <Link 
            to="/login" 
            className="px-4 py-1.5 bg-slate-950 hover:bg-slate-800 text-white text-xs font-semibold rounded-full transition-all shadow-sm"
          >
            Iniciar sesión
          </Link>

          {/* Mobile menu button */}
          <button 
            onClick={() => setOpen(v => !v)} 
            className="md:hidden p-1 text-slate-700 hover:text-slate-900"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {open && (
        <div className="pointer-events-auto w-full max-w-3xl mt-2 bg-white/95 backdrop-blur-md rounded-2xl border border-slate-200 shadow-xl p-4 flex flex-col gap-2 md:hidden">
          <Link 
            to="/" 
            onClick={() => setOpen(false)}
            className="text-xs font-semibold text-slate-700 hover:text-slate-900 py-2 px-3 rounded-lg hover:bg-slate-50"
          >
            Inicio
          </Link>
          <Link 
            to="/quienes-somos" 
            onClick={() => setOpen(false)}
            className="text-xs font-semibold text-slate-700 hover:text-slate-900 py-2 px-3 rounded-lg hover:bg-slate-50"
          >
            Nosotros
          </Link>
          <Link 
            to="/contacto" 
            onClick={() => setOpen(false)}
            className="text-xs font-semibold text-slate-700 hover:text-slate-900 py-2 px-3 rounded-lg hover:bg-slate-50"
          >
            Contacto
          </Link>
        </div>
      )}
    </header>
  );
}
